import Big from 'big.js';
import { truncateTotalLength } from 'helpers/assets';
import { formatAmount as formatAmount_ } from '@nbx/frontend-helpers/format';

const AMOUNT_MAX_LENGTH = 12;

export const formatAmount = (amount, min, decimalPrecisionDisplay) => {
  const amountBig = Big(amount);
  if (amountBig.gt(0) && amountBig.lt(min)) return `< ${min}`;

  const formatted = formatAmount_(amountBig, decimalPrecisionDisplay);
  return truncateTotalLength(formatted, AMOUNT_MAX_LENGTH);
};
